/**
 * 製品バージョンとビルド識別子。
 *
 * - version … ユーザー向けのリリース番号（手動で上げる）
 * - build   … CI の commit SHA など（VITE_APP_VERSION）。古い PWA キャッシュ検知用
 */

/** ユーザー向けバージョン表記。 */
export const APP_VERSION = '0.2.12';

/** ビルド識別子（短縮 SHA、またはローカルの `dev`）。 */
export function appBuildId(): string {
  const v = import.meta.env.VITE_APP_VERSION;
  if (typeof v !== 'string' || v.length === 0) return 'dev';
  return v.length > 12 ? v.slice(0, 7) : v;
}
